// extracted by mini-css-extract-plugin
module.exports = {"players":"Players_players__LpnnI","player":"Players_player__N0YHp","warning":"Players_warning__jQNPe"};